module.exports = __webpack_public_path__ + "static/promo-d9e49678c8b1a19644e181d57a7644fe.png";